import TimelineContainer from "../../Componant/BonusUI/Timeline";

const Timeline = () => {
  return (
    <div className="page-body">
      <TimelineContainer />
    </div>
  );
};

export default Timeline;
